import React, { useEffect, useState } from "react";
import Style from 'styles/components/case_study.module.scss';
import CaseStudyGrid from 'components/CaseStudyGrid';
import PageNation from 'components/PageNation';
import { useLocation } from "@reach/router";
import { case_study_list } from "src/constants";
import prepareImage from "src/images/prepare.png";

const ITEMS_PER_PAGE = 10;

const fetchCaseStudyList = async () => {
  try {
    const response = await fetch(case_study_list, { cache: "no-store" });
    if (!response.ok) {
      throw new Error("事例データの取得に失敗しました");
    }
    return await response.json();
  } catch (error) {
    console.error("fetchCaseStudyList エラー:", error);
    return [];
  }
};

export const useCaseStudy = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const loadCaseStudy = async () => {
      const json = await fetchCaseStudyList();
      if (!json) return setItems([]);
      // 表示順に並び替える
      const sortedJson = json.sort((a, b) => a.displayOrder - b.displayOrder);
      setItems(sortedJson);
    };

    loadCaseStudy().catch(error => {
      console.error("事例のロード中にエラーが発生しました:", error);
      setItems([]);
    });
  }, []);
  return items;
};

const CaseStudy = () => {
  const caseStudyList = useCaseStudy();
  const isEmpty = caseStudyList.length === 0;

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = Number(queryParams.get("page"));
  const currentPage = isNaN(page) || page < 1 ? 1 : page;
  
  const totalPages = Math.ceil(caseStudyList.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentCaseStudyList = caseStudyList.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  
  return (
    <div className={Style.case_study}>
      <h2 className={Style.caseStudy__title}>
        <span>事例一覧</span>
      </h2>
      <div className={Style.caseStudy__content}>
        {isEmpty ? (
          <div className={Style.caseStudy__empty}>
            <img src={prepareImage} alt="準備中" />
          </div>
        ) : (
          <CaseStudyGrid caseStudyList={currentCaseStudyList}/>
        )}
      </div>
      {!isEmpty && (
        <div className={Style.pagenation}>
          <PageNation
            page="/case_study"
            currentPage={currentPage}
            totalPages={totalPages}
          />
        </div>
      )}
    </div>
  );
};

export default CaseStudy;
